import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _isObject from "lodash/isObject";
import { createAction } from 'redux-act';
export var addTempData = createAction('Add temp data', function (key, val) {
  // allow for key, val or an object to be passed
  if (_isObject(key)) return key;
  return _defineProperty({}, key, val);
});
export var removeTempData = createAction('Remove temp data');